// Generated by genversion.
export const version = '2.16.0';
//# sourceMappingURL=version.js.map